// Array.prototype.at() — ES2022, missing in Safari <15.4 and Chrome <92.
// PostHog's bundled web-vitals collector calls .at(-1) inside
// PerformanceObserver callbacks, which throws on those browsers without this.
if (!Array.prototype.at) {
  Object.defineProperty(Array.prototype, 'at', {
    value(this: unknown[], n: number) {
      const idx = Math.trunc(n) || 0;
      return this[idx < 0 ? this.length + idx : idx];
    },
    writable: true,
    configurable: true,
  });
}
